import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n";

export default function CookieBanner() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("atlas_cookies");
    if (!stored) {
      setVisible(true);
    } else {
      try {
        setAnalytics(!!JSON.parse(stored).analytics);
      } catch { /* legacy string value */ }
    }
    const open = () => setVisible(true);
    window.addEventListener("atlas-open-cookies", open);
    return () => window.removeEventListener("atlas-open-cookies", open);
  }, []);

  const save = (a) => {
    localStorage.setItem("atlas_cookies", JSON.stringify({ necessary: true, analytics: a, at: new Date().toISOString() }));
    setAnalytics(a);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-[80] px-3 pb-3 sm:px-4 sm:pb-4">
      <div className="max-w-3xl mx-auto rounded-3xl bg-white border border-slate-200 shadow-2xl p-3.5 sm:p-5">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <p className="text-sm text-slate-600 flex-1">
            {t("cookie.text")}{" "}
            <Link to="/legal/cookies" data-testid="cookie-policy-link" className="text-[#FF6B35] font-medium hover:underline">
              {t("legal.cookies")}
            </Link>
          </p>
        </div>
        <div className="mt-3 sm:mt-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 justify-between">
          <button
            data-testid="cookie-analytics-toggle"
            onClick={() => setAnalytics(!analytics)}
            className="flex items-center gap-3 text-sm text-slate-700 min-h-[44px]"
          >
            <span className={`w-11 h-6 rounded-full p-0.5 transition-colors shrink-0 ${analytics ? "bg-[#FF6B35]" : "bg-slate-300"}`}>
              <span className={`block w-5 h-5 rounded-full bg-white shadow transition-transform ${analytics ? "translate-x-5" : ""}`} />
            </span>
            {t("cookie.analytics")}
          </button>
          <div className="grid grid-cols-3 sm:flex gap-2 w-full sm:w-auto shrink-0">
            <button data-testid="cookie-reject" onClick={() => save(false)}
              className="rounded-full border border-slate-200 px-2 sm:px-5 py-2 min-h-[44px] font-mono-t text-[10px] sm:text-[11px] font-bold uppercase tracking-widest text-slate-500 hover:border-slate-400 transition-colors whitespace-nowrap">
              {t("cookie.reject")}
            </button>
            <button data-testid="cookie-accept" onClick={() => save(analytics || true)}
              className="rounded-full bg-[#FF6B35] text-white px-2 sm:px-5 py-2 min-h-[44px] font-mono-t text-[10px] sm:text-[11px] font-bold uppercase tracking-widest hover:bg-[#E8551F] transition-colors whitespace-nowrap">
              {t("cookie.accept")}
            </button>
            <button data-testid="cookie-save" onClick={() => save(analytics)}
              className="rounded-full bg-[#1E293B] text-white px-2 sm:px-5 py-2 min-h-[44px] font-mono-t text-[10px] sm:text-[11px] font-bold uppercase tracking-widest hover:bg-slate-700 transition-colors whitespace-nowrap">
              {t("cookie.save")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
